<template>
   <div class="container">
       <!--element which is going to render the Card-->
        <div v-if="!isEmailSubmitted">
          <email-verification
            ref="refEmailVerification"
            :page-title="title"
            :erorrMessage = "emailSubmitErorrMessage"
            :isSubmitted = "isEmailSubmitted"
            @submit="onSubmitEmail" />
        </div>
        <div v-else>
          <security-code-verification ref="refSecurityCodeVerification"
                                      @isSecurityCodeSuccess="isSecurityCodeSuccess($event)" />
          <p>
            <span style="color: #0a3576; font-weight: 500;"> {{ username }} </span>
                      if you think you entered your email address incorrectly, please
            <ejs-button
                cssClass="e-link"
                v-on:click.native="tryAgain"
                style="padding: 3px">
                Try Again.
            </ejs-button>
          </p>
        </div>
        <!-- <div>
          <div tabindex="0" class="e-card" id="basic" v-if="isEmailSubmitted">
          <div class="e-card-title">{{ title }}: Verify Your Email Address</div>
          <div class="e-card-separator"></div>
            <div class="e-card-content margin-color-verify-section">
                <div>
                  <p style="text-align: justify;">
                    A verification link has been sent to your email account.
                    Please click on the link that has just been sent to your email account
                    to verify your email and complete your registration process.
                    This includes a time sensitive link.
                    If you don’t receive an email, please check your spam folder or contact
                    <span style="font-weight: 500;">1-888-413-0099.</span>
                  </p>
                </div>
                <div class="align-center-bottom">
                 <p>
                   <span style="color: #0a3576; font-weight: 500;"> {{ username }} </span>
                      if you think you entered your email address incorrectly, please
                      <ejs-button
                        cssClass="e-link"
                        v-on:click.native="tryAgain"
                        style="padding: 3px"
                      >
                        Try Again.
                      </ejs-button>
                  </p>
                </div>
            </div>
          </div>
        </div> -->
      </div>
</template>

<script>
import Vue from 'vue';

import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import EmailVerification from '../components/email-verification.vue';
import SecurityCodeVerification from '../components/security-code-verification.vue';

// import SccInputValidator from '../../../components/base/scc-input-validator.vue';

import { CONFIRM_USER_EMAIL } from '../store';

Vue.use(TextBoxPlugin);
Vue.use(ButtonPlugin);

export default {
  name: 'RegistrationPage',
  components: {
    EmailVerification,
    SecurityCodeVerification,
    // SccInputValidator,
  },
  mounted() {
  },
  computed: {
  },
  data() {
    return {
      title: 'Register',
      // isHideCreateAccount: false,
      // isHideVerifySection: true,
      username: null,
      isEmailValid: false,
      loginErorrMessage: null,
      isEmailSubmitted: false,
      emailSubmitErorrMessage: null,
    };
  },
  watch: {
  },
  methods: {
    isSecurityCodeSuccess(event) {
      if (event && event.isSuccess) this.$router.push('/new-user');
    },
    async onSubmitEmail(email) {
      // this.$parent.notificationToasts.length = 0;
      const refEmailVerify = this.$refs.refEmailVerification;
      const userName = email;
      const rootURL = window.location.host;
      if (refEmailVerify.isEmailValid) {
        try {
        // await this.$store.dispatch(CONFIRM_REGISTER_USER_EMAIL, { userName, rootURL });
          await this.$store.dispatch(CONFIRM_USER_EMAIL, { userName, rootURL, confirmType: 'registration' });
          if (this.$store.getters.userDetails.status === 200) {
            this.$parent.notificationToasts.push({
              title: 'Success!',
              content: 'A verification code has been sent to your email account.',
              cssClass: 'e-toast-success',
              timeOut: 5000,
            });
            this.username = userName;
            this.isEmailSubmitted = true;
            // this.$router.push('/new-user');
            // this.isHideCreateAccount = true;
          } else if (this.$store.getters.userDetails.err) {
            switch (this.$store.getters.userDetails.err.status) {
              case 403:
                this.loginErorrMessage = 'Account exist with given email id.';
                break;
              case 404:
                this.$router.push('/NotFound');
                break;
              default:
                this.loginErorrMessage = 'Oops, Something went wrong. We are working on getting this fixed as soon as we can. You may be able to try again shortly. If you continue to experience this issue, you can contact ASCA Tanks at ascatanks@safetycodes.ab.ca or call 1-888-413-0099';
            }
            if (this.loginErorrMessage) {
              this.$parent.notificationToasts.push({
                title: 'Error!',
                content: this.loginErorrMessage,
                cssClass: 'e-toast-danger',
                timeOut: 5000,
              });
            }
          }
        } catch (err) {
          switch (err.status) {
            case 403:
              this.loginErorrMessage = 'Account exist with given email id.';
              break;
            case 404:
              this.$router.push('/NotFound');
              break;
            default:
              this.loginErorrMessage = 'Oops, Something went wrong. We are working on getting this fixed as soon as we can. You may be able to try again shortly. If you continue to experience this issue, you can contact ASCA Tanks at ascatanks@safetycodes.ab.ca or call 1-888-413-0099';
          }
          if (this.loginErorrMessage) {
            this.$parent.notificationToasts.push({
              title: 'Error!',
              content: this.loginErorrMessage,
              cssClass: 'e-toast-danger',
              timeOut: 5000,
            });
          }
        }
      } else {
        // to triger validation indicator for initially empty field
        // this.username = this.username === null ? '' : this.username;
        refEmailVerify.validateEmail();
        this.$parent.notificationToasts.push({
          title: 'Error!', content: 'Please provide valid email id.', cssClass: 'e-toast-danger', timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) { this.$parent.$refs.notifierRef.show(); }
    },
    tryAgain() {
      this.loginErorrMessage = null;
      this.isEmailSubmitted = false;
      // this.isHideCreateAccount = false;
    },
  },
};
</script>
<style>
.container {
  padding: 16px 15% 16px 15%;
}
</style>
